import AceEditor from 'react-ace';
import Beautify from 'ace-builds/src-noconflict/ext-beautify';
import { useEffect, useRef } from 'react';
import useMounted from 'hooks/useMounted';

const Modal = ({ data, onClose }) => {
  const ref = useRef(null);

  const onClick = (e) => {
    if (e.target.id === 'Modal') {
      onClose();
    }
  };

  const onEscape = (e) => {
    if (e.key === 'Escape') {
      onClose();
    }
  };

  useMounted(() => {
    if (ref && ref.current) {
      Beautify.beautify(ref.current.editor.session);
    }
    const modal = document.getElementById('Modal');
    modal.addEventListener('click', onClick);
    document.addEventListener('keyup', onEscape);
  });

  useEffect(() => {
    return () => {
      document.removeEventListener('keyup', onEscape);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div id="Modal" className="Modal">
      <div className="ModalCard">
        <div className="Title">
          {data.title}
          <button onClick={onClose}>
            Close
          </button>
        </div>
        <div className="Body">
          <div className="Description">
            {data.description}
          </div>
          {data.example &&
            <div className="Example">
              <div className="Title">Example</div>
              <div className="ExampleEditor">
                <AceEditor
                  ref={ref}
                  width="100%"
                  height="300px"
                  mode={data.lang || 'javascript'}
                  theme="monokai"
                  name="Editor"
                  showGutter={false}
                  showPrintMargin={false}
                  defaultValue={data.example}
                  commands={Beautify.commands}
                  tabSize={2}
                  readOnly
                />
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  );
};

export default Modal;